import React from 'react';

export const getLastDebitMeasure = async (
  value: any,
  Api: {
    getLastDebitMeasure: Function;
  },
  setDebit: React.Dispatch<any>,
) => {
  try {
    const response = await Api.getLastDebitMeasure(value);
    setDebit(response.data);
  } catch (error) {
    console.log(error);
  }
};

// function to replace values above limits (24h for times or 1000 for startups)
export const checkLimits = (pData: any, pOutField: string) => {
  const limits = pOutField === 'prTemps' ? 24 : 1000;
  const copyData = JSON.parse(JSON.stringify(pData)); // Deep copy to avoid mutating original data
  if (copyData?.measures?.length > 0) {
    copyData.measures = copyData.measures.map((n: any) => ({
      ...n,
      value: n.value > limits ? limits : n.value,
    }));
  }
  return copyData;
};
